import { EyeOutlined } from '@ant-design/icons';
import { Button, Space, Tooltip } from 'antd';
import React, { useRef } from 'react';
import { useHistory } from 'react-router-dom';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import TableAndFilters from '../../components/TableAndFilters';
import { estadosComision } from '../../utils';
import { fieldTypes } from '../../utils/filter-utils';

function ComisionList() {
  const tableRef = useRef();
  const history = useHistory();

  const columns = [
    {
      title: 'Asegurado',
      dataIndex: ['pago', 'poliza', 'solicitud', 'solicitante'],
      key: 'solicitante',
      render: (solicitante) => {
        if (solicitante) {
          const solicitud = JSON.parse(solicitante);
          const nombres = solicitud?.empresaJuridica
            ? `${solicitud?.empresaJuridica?.razon}`
            : `${solicitud?.persona?.nombres}`;
          return nombres;
        }
        return '-';
      },
      width: '20%'
    },
    {
      title: 'Nro documento',
      dataIndex: ['pago', 'poliza', 'solicitud', 'solicitante'],
      key: 'solicitante',
      render: (solicitante) => {
        if (solicitante) {
          const solicitud = JSON.parse(solicitante);
          const nroDoc = solicitud?.empresaJuridica
            ? `${solicitud?.empresaJuridica?.ruc}`
            : `${solicitud?.persona?.cedula}`;
          return nroDoc;
        }
        return '-';
      },
      width: '20%'
    },
    {
      title: 'Aseguradora',
      dataIndex: [
        'pago',
        'poliza',
        'aseguradoraEmpresa',
        'aseguradora',
        'descripcion'
      ],

      filterType: fieldTypes.STRING,
      sortable: true
    },
    {
      title: 'Producto',
      dataIndex: ['pago', 'poliza', 'producto', 'descripcion'],
      width: '20%',
      filterType: fieldTypes.STRING,
      sortable: true
    },
    {
      title: 'Nro de Póliza ',
      dataIndex: ['pago', 'poliza', 'numero'],
      width: '10px',
      filterType: fieldTypes.NUMERIC,
      sortable: true
    },
    {
      title: 'Endoso ',
      dataIndex: ['pago', 'poliza', 'endoso'],
      width: '10px',
      filterType: fieldTypes.NUMERIC,
      sortable: true
    },
    {
      title: 'Nro de Cuota ',
      dataIndex: ['pago', 'cuota_numero'],
      width: '10px',
      filterType: fieldTypes.NUMERIC,
      sortable: true
    },
    {
      title: 'Monto de Cuota',
      dataIndex: ['pago', 'monto'],
      width: '10px',
      filterType: fieldTypes.NUMERIC,
      sortable: true
    },
    {
      title: 'Comisión',
      dataIndex: 'monto',
      width: '10px',
      filterType: fieldTypes.NUMERIC,
      sortable: true
    },
    {
      title: 'Iva Comisión',
      dataIndex: 'iva',
      width: '10px',
      filterType: fieldTypes.NUMERIC,
      sortable: true
    },
    {
      title: 'Comisión Iva Incluido',
      dataIndex: 'comision_iva_incluido',
      width: '10px',
      filterType: fieldTypes.NUMERIC,
      sortable: true
    },
    {
      title: 'Estado',
      dataIndex: 'estado',
      width: '10px',
      filterType: fieldTypes.ENUM,
      filters: Object.keys(estadosComision).map((key) => ({
        text: estadosComision[key],
        value: key
      })),
      sortable: true
    },
    {
      title: 'Acciones',
      key: 'action',
      width: '10px',
      align: 'center',
      render: (text, record) => (
        <Space size="small">
          <Tooltip title="Ver póliza">
            <Button
              type="text"
              icon={<EyeOutlined />}
              size="middle"
              onClick={() =>
                handleOpenUrl(`polizas/${record.pago.poliza.token}`)
              }
            />
          </Tooltip>
        </Space>
      )
    }
  ];

  const handleOpenUrl = (url) => {
    history.push(url);
  };

  return (
    <ResponsiveContainer size="large">
      <TableAndFilters
        ref={tableRef}
        withGeneralFilter
        url="/comisiones"
        title="Comisiones"
        columns={columns}
        showTable
      />
    </ResponsiveContainer>
  );
}

export default ComisionList;
